import {baseAPI} from './BaseAPI';
import {EarlyAccessApplication, EarlyAccessApplicationResult, PublicRegistrationConfig, PublicLegalDocument, LegalDocumentAction} from '../models/IRegistration';

export const registrationAPI = baseAPI.injectEndpoints({
    endpoints: build => ({
        getLegalDocuments: build.query<PublicLegalDocument[], string>({
            query: language => ({url: 'public/legal-documents', params: {language}, method: 'GET'}),
        }),
        getPublicRegistrationConfig: build.query<PublicRegistrationConfig, void>({
            query: () => ({url: 'public/config', method: 'GET'}),
        }),
        applyForEarlyAccess: build.mutation<EarlyAccessApplicationResult, EarlyAccessApplication>({
            query: body => ({url: 'early-access/applications', method: 'POST', body}),
        }),
        register: build.mutation<void, {email: string; password: string; legalDocumentActions: LegalDocumentAction[]}>({
            query: body => ({url: 'Users/Registration', method: 'POST', body}),
        }),
    }),
});
